import {
  AccountRelatedPath,
  getAccountRelatedUrl,
  PaginationQueryParams,
} from '@/config/urls'
import { composePathAndParams, joinValues } from '@/utils/urls'

export const referralUrls = {
  getReferrals: ({
    workspaceId,
    params,
  }: AccountRelatedPath & { params?: PaginationQueryParams }): string => {
    const path = joinValues(getAccountRelatedUrl(workspaceId), 'referrals')
    return composePathAndParams(path, params)
  },
  getReferral: ({
    workspaceId,
    referralId,
  }: AccountRelatedPath & { referralId: string }): string =>
    joinValues(getAccountRelatedUrl(workspaceId), 'referrals', referralId),
  getTrial: ({ workspaceId }: { workspaceId: string }): string =>
    joinValues(getAccountRelatedUrl(workspaceId), 'trial'),
  getDowngrade: ({ workspaceId }: { workspaceId: string }): string =>
    joinValues(getAccountRelatedUrl(workspaceId), 'downgrade'),
}
